import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

/**
 * Longest CV text (characters) the paste-your-CV import reads. Mirrors the
 * server's `PARSER_PROMPT_MAX_CHARS` (the most résumé text one AI call reads); a
 * contract test in `parser.config.spec.ts` keeps the two equal. The client stops
 * submit above it, and the server answers anything longer with a 422
 * `TEXT_TOO_LONG` rather than silently cutting it.
 */
export const RESUME_PASTE_MAX_CHARS = 22_000;

/**
 * Hard ceiling the request schema enforces, only to bound payload size. It sits
 * above `RESUME_PASTE_MAX_CHARS` on purpose: a global Zod pipe rejects with a
 * generic 400, so text between the two limits must reach the service, which
 * returns the specific, localisable 422 `TEXT_TOO_LONG`. Kept under Express's
 * default 100 kB JSON body limit for typical (1 to 2 byte) scripts.
 */
export const RESUME_PASTE_HARD_CEILING_CHARS = 50_000;

/** POST /resume-parser/parse-text: CV text pasted instead of an uploaded file. */
export const parseTextSchema = z
  .object({
    text: z.string().max(RESUME_PASTE_HARD_CEILING_CHARS, {
      message: `Pasted text is too large. Keep it under ${RESUME_PASTE_HARD_CEILING_CHARS} characters.`,
    }),
  })
  .strict();

export class ParseTextDto extends createZodDto(parseTextSchema) {}
